import {
  transport,
  useTransportMutation,
  useTransportQuery,
  useTransportQueryUtils,
} from "@/transport"

export function useConversationMetricsWorkspaceSettingsTransport() {
  return useTransportQuery({
    operation: transport.operations.getWorkspaceSettings,
    request: {},
  })
}

export function useConversationMetricsConfigurationTransport() {
  const {
    data: workspaceSettings,
    isError,
    isLoading,
    refetch: retrySettings,
  } = useConversationMetricsWorkspaceSettingsTransport()
  const { mutateAsync: updateSettings, isPending: isUpdatingSettings } =
    useTransportMutation(transport.operations.updateWorkspaceSettings)
  const transportUtils = useTransportQueryUtils()

  return {
    workspaceSettings,
    isError,
    isLoading,
    retrySettings,
    updateSettings,
    isUpdatingSettings,
    invalidateSettings: () =>
      void transportUtils.invalidateResource("workspace-settings"),
  }
}
